import React, { useContext } from 'react';
import {
  Modal as ModalSUI,
  ModalBody,
  ModalHeader,
} from '@one-thd/sui-atomic-components';
import { NationalAccountContext } from '../../../../../contexts';

export const Modal = ({ title, children }: any): JSX.Element => {
  const { showModal, setShowModal } = useContext(NationalAccountContext);
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <ModalSUI open={showModal} onClose={handleClose}>
        <ModalHeader onClose={handleClose}>{title}</ModalHeader>
        <ModalBody>{children}</ModalBody>
      </ModalSUI>
    </>
  );
};
